interface ITypeLevel {
  id: number
  name: string
  slug: TTypeLevel
}

export type TTypeLevel = 'is_migration' | 'is_tourism' | 'is_work'

export const typeLevels: ITypeLevel[] = [
  {
    id: 0,
    name: 'туризму',
    slug: 'is_tourism',
  },
  {
    id: 1,
    name: 'роботи',
    slug: 'is_work',
  },
  {
    id: 2,
    name: 'міграції',
    slug: 'is_migration',
  },
]

export const typeLevelsKids: ITypeLevel[] = [
  {
    id: 0,
    name: 'туризму',
    slug: 'is_tourism',
  },
  {
    id: 1,
    name: 'навчання',
    slug: 'is_work',
  },
  {
    id: 2,
    name: 'міграції',
    slug: 'is_migration',
  },
]

export interface ILevel {
  id: string
  name: string
  is_work: boolean
  is_tourism: boolean
  is_migration: boolean
  status: boolean
}
